import { ErrorsTranslation } from './errors.translation.pl';

export const errorsTranslation: ErrorsTranslation = {
  permissionError: {
    button: 'OK',
    message: 'You do not have sufficient permissions to perform this action.',
    title: 'Access Denied',
  },
};
